import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import "hammerjs";
import { environment } from "./environments/environment";
import { AppModule } from "./app/+ui/app.module";

// const spy = create();

// Local Env
//let loc = "symbol/svg/sprite.symbol.svg";

// DevServer Env
let loc = "https://cdn.ats.careers/geniusats/build/ats/assets/sprite_202406.symbol.svg";

if (environment.nightly) {
  //   loc = 'nightly/symbol/svg/sprite.symbol.svg';
} else if (environment.production) {
  //   loc = 'prod/symbol/svg/sprite.symbol.svg';
  enableProdMode();
}

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

window.addEventListener("resize", (e) => {
  let vh2 = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh2}px`);
});

/* SVG insert script */
const xhr = new XMLHttpRequest();

xhr.open("GET", loc, true);
xhr.onload = (e) => {
  if (xhr.readyState === 4) {
    if (xhr.status === 200) {
      let body = document.body;
      const element = document.createElement("div");
      element.innerHTML = xhr.responseText;
      body.insertBefore(element, body.firstChild);
    } else {
      console.error("SVGs failed to load");
    }
  }
};

xhr.send(null);

/* Local SVG insert script */
// fetch(loc)
//     .then(resp => resp.text())
//     .then(getLocalSVGs => {
//         let body = document.body;
//         const element = document.createElement('div');
//         element.innerHTML = getLocalSVGs;
//         body.insertBefore(element, body.firstChild);
//     })
//     .catch((error) => {
//         console.error('Error:', error);
//     });

// let supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
const supportsTouch = 'ontouchstart' in window || navigator.maxTouchPoints;

if (supportsTouch === true) {
  document.body.classList.add("js-touch__device");
}

// import { TextDecoder } from "text-encoding";
// if (!window["TextDecoder"]) {
//   window["TextDecoder"] = TextDecoder;
// }

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
